setTimeout(() => {


    console.log('custom testing');
    const targetNode = document.querySelector('.single-option-selector'); // visible location dropdown

    console.log('test', document.querySelector('.single-option-selector'));
    let btncont = document.querySelector('.scwp-actions');
    let qtycont = document.getElementById('quantity-input')
        ? document.getElementById('quantity-input').parentElement
        : null;
    let priceElement = document.querySelector('.scwp-details .price');
    let locationOptionsContainer = document.querySelector('.scwp-details .scwp-options');
    let btnelement = document.getElementById('add-to-cart-btn');

    const californiaEtcRestrictedProducts = [
        'eco-friendly-9-0-colossal-boba-drinking-straws-500-count-wrapped',
        '9-colossal-boba-straw-720-count',
        '5-eco-stirrers-6000-count',
        '5-75-black-cocktail-straws-6000-count',
        'eco-friendly-7-75-black-jumbo-drinking-straws-3750-count-wrapped',
        '16oz-paper-hot-cups-with-lids-sealife-80-count',
        '12oz-paper-hot-cups-with-lids-squiggle-multi-color-80-count'
    ];

    const coloradoWashingtonRestrictedProducts = [
        '7-75-jumbo-wrapped-eco-straws-3750-count',
        '10-25-giant-wrapped-eco-straws-2000-count',
        '8-5-giant-wrapped-eco-straws-1200-count',
        '7-75-jumbo-eco-straws-one-50-ct-phade-box',
        '7-75-jumbo-eco-straws-unwrapped-6000-ct-phade-box',
        '5-eco-stirrers-6000-count',
        '9-colossal-boba-straw-720-count',
        'eco-friendly-9-0-colossal-boba-drinking-straws-500-count-wrapped',
        '100-compostable-cutlery-set-225-count-bulk-wrapped',
        '100-compostable-spoons-400-count-bulk-wrapped',
        '100-compostable-knives-530-count-bulk-wrapped',
        '100-compostable-forks-350-count-bulk-wrapped',
        '100-compostable-spoons-650-count-bulk-unwrapped',
        '100-compostable-knives-750-count-bulk-unwrapped',
        '100-compostable-forks-550-count-unwrapped'
    ];

    const californiaEtcStates = ['California', 'Colorado', 'Maryland', 'Minnesota', 'Washington'];
    const coloradoWashingtonStates = ['Colorado', 'Washington'];

    const productNameEl = document.querySelector('.product_name');
    const newDiv = document.createElement('div');
    newDiv.id = 'prod_not_available_message';

    const callback = function() {

        let selectedLocation = '';
        if (targetNode && targetNode.options[targetNode.selectedIndex]) {
            selectedLocation = targetNode.options[targetNode.selectedIndex].textContent;
        }

        console.log(selectedLocation);


        if (btnelement) btnelement.dataset.vid = 'test';

        // Shopify-safe product handle extraction
        let pathParts = window.location.pathname.split('/').filter(Boolean);
        let currentProduct = pathParts[pathParts.length - 1];


        // Select your location: ??
        // Hide if selected-location contains all: ['Colorado', 'Washington']
        // .. and the link is in restricted array
        if (coloradoWashingtonStates.every(state => selectedLocation.includes(state)) && coloradoWashingtonRestrictedProducts.includes(currentProduct) ) {
            console.log('hiding this product 1');
            document.getElementsByClassName('purchase-details__buttons')[0].style.visibility='hidden';
            document.getElementsByClassName('purchase-details__quantity')[0].style.visibility='hidden';
            document.getElementsByClassName('modal_price')[0].style.visibility='hidden';

            if (productNameEl) {
                console.log(newDiv);
                newDiv.innerHTML = '<strong>This product is not available for shipping to Colorado and Washington.</strong>';
                productNameEl.parentNode.insertBefore(newDiv, productNameEl.nextSibling);
            }
        }

        // Select your location: ??
        // Hide if selected-location contains all: ['California', 'Colorado', 'Maryland', 'Minnesota', 'Washington'];
        // .. and the link is in restricted array
        else if ( californiaEtcStates.every(state => selectedLocation.includes(state)) && californiaEtcRestrictedProducts.includes(currentProduct)) {
           console.log('hiding this product 2');
           document.getElementsByClassName('purchase-details__buttons')[0].style.visibility='hidden';
           document.getElementsByClassName('purchase-details__quantity')[0].style.visibility='hidden';
           document.getElementsByClassName('modal_price')[0].style.visibility='hidden';

            if (productNameEl) {
                newDiv.innerHTML = '<strong>This product is not available for shipping to California, Colorado, Maryland, Minnesota, and Washington. </strong>';
                console.log(newDiv);
                productNameEl.parentNode.insertBefore(newDiv, productNameEl.nextSibling);
            }
        }

        // No restriction
        else {
            console.log('showing this product');
            document.getElementsByClassName('purchase-details__buttons')[0].style.visibility='visible';
            document.getElementsByClassName('purchase-details__quantity')[0].style.visibility='visible';
            document.getElementsByClassName('modal_price')[0].style.visibility='visible';

            if(document.getElementById('prod_not_available_message')) {
                document.getElementById('prod_not_available_message').innerHTML = '';
            }
        }
    };

    if (targetNode) {
        targetNode.addEventListener('change', callback);
        setTimeout(callback, 100);
    } else {
        console.log('Location selector #location-select not found.');
    }

},100);
    
